<template>
    <router-view></router-view> <!-- ルートに基づいてコンポーネントを表示 -->
</template>

<script>
import { useHead } from '@unhead/vue';
import { onMounted } from 'vue';

export default {
  name: 'App',

  setup () {
    useHead({
      title: '家計の道しるべ',
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
        { name: 'description', content: '家計に詳しいアナグマさんと一緒にあなたに合った出口を見つけましょう。' },
        { name: 'og:title', content: '家計の道しるべ' },
      ],
      script: [
        {
          async: true,
          src: `https://www.googletagmanager.com/gtag/js?id=${process.env.VUE_APP_GA_MEASUREMENT_ID}`
        }
      ]
    });

    onMounted(() => {
      // Google Analytics初期化
      if (process.env.VUE_APP_GA_MEASUREMENT_ID) {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function() {
          window.dataLayer.push(arguments);
        };
        window.gtag('js', new Date());
        window.gtag('config', process.env.VUE_APP_GA_MEASUREMENT_ID, {
          page_title: document.title,
          page_location: window.location.href
        });
      }

      const loading = document.getElementById('loading');
      const app = document.getElementById('app');
      if (loading) {
        loading.style.display = 'none';
        app.style.display = 'block';
      }
      const requireImages = require.context('@/assets/images', false, /\.(png|jpg|jpeg|svg|webp)$/);
      const images = requireImages.keys().map(requireImages);
      images.forEach((image) => {
        const img = new Image();
        img.src = image;
      });
    });
  },
}
</script>
<style>
.zen-maru-gothic-light {
  font-family: "Zen Maru Gothic", sans-serif;
  font-weight: 300;
  font-style: normal;
}

.zen-maru-gothic-regular {
  font-family: "Zen Maru Gothic", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.zen-maru-gothic-medium {
  font-family: "Zen Maru Gothic", sans-serif;
  font-weight: 500;
  font-style: normal;
}

.zen-maru-gothic-bold {
  font-family: "Zen Maru Gothic", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.zen-maru-gothic-black {
  font-family: "Zen Maru Gothic", sans-serif;
  font-weight: 900;
  font-style: normal;
}


body {
  margin: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #75523a;
  overflow-x: hidden;
  color: #fff;
  font-weight: 400;
  font-style: normal;
  text-align: center;
  background-position: 50% 100%;
  overflow-x: hidden;
}
body,
input {
    font-family: "Zen Maru Gothic", sans-serif;
}

  body:has(.fadein),
  body:has(.fadeout) {
    &::after {
      /* background-color: #0006; */
      content: '';
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    }
  }

body:has(.start-container,.explanation-container) {
  background-color: #3d2618;
  #app {
    max-width: 500px;
    margin-inline: auto;
    background-color: #4C301D;
    background-image:
      url('@/assets/images/background__start02.webp'),
      url('@/assets/images/background__start01.webp'),
      none;
    background-position-x: 100%, 0, 0;
    background-position-y: 0, 100%, 0;
    background-repeat: 
    repeat-y,
    repeat-y,
    no-repeat
    ;
    background-size: calc(240px + 25%),calc(240px + 25%),auto;
    /* background-attachment: fixed; */
  }
}

body:has(.progress-bar) {
  /* background-color: #4C301D; */
  background-image: url('@/assets/images/background.webp');
  background-repeat: no-repeat;
  background-attachment: fixed;
  /* transition: all 200ms 0s ease-out; */
}

body.fade:has(.fadeout) {
    transition: all 400ms 0s ease;
}

  body:has(.progress-bar.progress-01), body.fade:has(.progress-bar.next-progress-01) {background-position: 50% 99%;}
  body:has(.progress-bar.progress-02), body.fade:has(.progress-bar.next-progress-02) {background-position: 50% 98%;}
  body:has(.progress-bar.progress-03), body.fade:has(.progress-bar.next-progress-03) {background-position: 50% 97%;}
  body:has(.progress-bar.progress-04), body.fade:has(.progress-bar.next-progress-04) {background-position: 50% 96%;}
  body:has(.progress-bar.progress-05), body.fade:has(.progress-bar.next-progress-05) {background-position: 50% 95%;}
  body:has(.progress-bar.progress-06), body.fade:has(.progress-bar.next-progress-06) {background-position: 50% 94%;}
  body:has(.progress-bar.progress-07), body.fade:has(.progress-bar.next-progress-07) {background-position: 50% 93%;}
  body:has(.progress-bar.progress-08), body.fade:has(.progress-bar.next-progress-08) {background-position: 50% 92%;}
  body:has(.progress-bar.progress-09), body.fade:has(.progress-bar.next-progress-09) {background-position: 50% 91%;}
  body:has(.progress-bar.progress-10), body.fade:has(.progress-bar.next-progress-10) {background-position: 50% 90%;}
  body:has(.progress-bar.progress-11), body.fade:has(.progress-bar.next-progress-11) {background-position: 50% 89%;}
  body:has(.progress-bar.progress-12), body.fade:has(.progress-bar.next-progress-12) {background-position: 50% 88%;}
  body:has(.progress-bar.progress-13), body.fade:has(.progress-bar.next-progress-13) {background-position: 50% 87%;}
  body:has(.progress-bar.progress-14), body.fade:has(.progress-bar.next-progress-14) {background-position: 50% 86%;}
  body:has(.progress-bar.progress-15), body.fade:has(.progress-bar.next-progress-15) {background-position: 50% 85%;}
  body:has(.progress-bar.progress-16), body.fade:has(.progress-bar.next-progress-16) {background-position: 50% 84%;}
  body:has(.progress-bar.progress-17), body.fade:has(.progress-bar.next-progress-17) {background-position: 50% 83%;}
  body:has(.progress-bar.progress-18), body.fade:has(.progress-bar.next-progress-18) {background-position: 50% 82%;}
  body:has(.progress-bar.progress-19), body.fade:has(.progress-bar.next-progress-19) {background-position: 50% 81%;}
  body:has(.progress-bar.progress-20), body.fade:has(.progress-bar.next-progress-20) {background-position: 50% 80%;}
  body:has(.progress-bar.progress-21), body.fade:has(.progress-bar.next-progress-21) {background-position: 50% 79%;}
  body:has(.progress-bar.progress-22), body.fade:has(.progress-bar.next-progress-22) {background-position: 50% 78%;}
  body:has(.progress-bar.progress-23), body.fade:has(.progress-bar.next-progress-23) {background-position: 50% 77%;}
  body:has(.progress-bar.progress-24), body.fade:has(.progress-bar.next-progress-24) {background-position: 50% 76%;}
  body:has(.progress-bar.progress-25), body.fade:has(.progress-bar.next-progress-25) {background-position: 50% 75%;}
  body:has(.progress-bar.progress-26), body.fade:has(.progress-bar.next-progress-26) {background-position: 50% 74%;}
  body:has(.progress-bar.progress-27), body.fade:has(.progress-bar.next-progress-27) {background-position: 50% 73%;}
  body:has(.progress-bar.progress-28), body.fade:has(.progress-bar.next-progress-28) {background-position: 50% 72%;}
  body:has(.progress-bar.progress-29), body.fade:has(.progress-bar.next-progress-29) {background-position: 50% 71%;}
  body:has(.progress-bar.progress-30), body.fade:has(.progress-bar.next-progress-30) {background-position: 50% 70%;}
  body:has(.progress-bar.progress-31), body.fade:has(.progress-bar.next-progress-31) {background-position: 50% 69%;}
  body:has(.progress-bar.progress-32), body.fade:has(.progress-bar.next-progress-32) {background-position: 50% 68%;}
  body:has(.progress-bar.progress-33), body.fade:has(.progress-bar.next-progress-33) {background-position: 50% 67%;}
  body:has(.progress-bar.progress-34), body.fade:has(.progress-bar.next-progress-34) {background-position: 50% 66%;}
  body:has(.progress-bar.progress-35), body.fade:has(.progress-bar.next-progress-35) {background-position: 50% 65%;}
  body:has(.progress-bar.progress-36), body.fade:has(.progress-bar.next-progress-36) {background-position: 50% 64%;}
  body:has(.progress-bar.progress-37), body.fade:has(.progress-bar.next-progress-37) {background-position: 50% 63%;}
  body:has(.progress-bar.progress-38), body.fade:has(.progress-bar.next-progress-38) {background-position: 50% 62%;}
  body:has(.progress-bar.progress-39), body.fade:has(.progress-bar.next-progress-39) {background-position: 50% 61%;}
  body:has(.progress-bar.progress-40), body.fade:has(.progress-bar.next-progress-40) {background-position: 50% 60%;}
  body:has(.progress-bar.progress-41), body.fade:has(.progress-bar.next-progress-41) {background-position: 50% 59%;}
  body:has(.progress-bar.progress-42), body.fade:has(.progress-bar.next-progress-42) {background-position: 50% 58%;}
  body:has(.progress-bar.progress-43), body.fade:has(.progress-bar.next-progress-43) {background-position: 50% 57%;}
  body:has(.progress-bar.progress-44), body.fade:has(.progress-bar.next-progress-44) {background-position: 50% 56%;}
  body:has(.progress-bar.progress-45), body.fade:has(.progress-bar.next-progress-45) {background-position: 50% 55%;}
  body:has(.progress-bar.progress-46), body.fade:has(.progress-bar.next-progress-46) {background-position: 50% 54%;}
  body:has(.progress-bar.progress-47), body.fade:has(.progress-bar.next-progress-47) {background-position: 50% 53%;}
  body:has(.progress-bar.progress-48), body.fade:has(.progress-bar.next-progress-48) {background-position: 50% 52%;}
  body:has(.progress-bar.progress-49), body.fade:has(.progress-bar.next-progress-49) {background-position: 50% 51%;}
  body:has(.progress-bar.progress-50), body.fade:has(.progress-bar.next-progress-50) {background-position: 50% 50%;}
  body:has(.progress-bar.progress-51), body.fade:has(.progress-bar.next-progress-51) {background-position: 50% 49%;}
  body:has(.progress-bar.progress-52), body.fade:has(.progress-bar.next-progress-52) {background-position: 50% 48%;}
  body:has(.progress-bar.progress-53), body.fade:has(.progress-bar.next-progress-53) {background-position: 50% 47%;}
  body:has(.progress-bar.progress-54), body.fade:has(.progress-bar.next-progress-54) {background-position: 50% 46%;}
  body:has(.progress-bar.progress-55), body.fade:has(.progress-bar.next-progress-55) {background-position: 50% 45%;}
  body:has(.progress-bar.progress-56), body.fade:has(.progress-bar.next-progress-56) {background-position: 50% 44%;}
  body:has(.progress-bar.progress-57), body.fade:has(.progress-bar.next-progress-57) {background-position: 50% 43%;}
  body:has(.progress-bar.progress-58), body.fade:has(.progress-bar.next-progress-58) {background-position: 50% 42%;}
  body:has(.progress-bar.progress-59), body.fade:has(.progress-bar.next-progress-59) {background-position: 50% 41%;}
  body:has(.progress-bar.progress-60), body.fade:has(.progress-bar.next-progress-60) {background-position: 50% 40%;}
  body:has(.progress-bar.progress-61), body.fade:has(.progress-bar.next-progress-61) {background-position: 50% 39%;}
  body:has(.progress-bar.progress-62), body.fade:has(.progress-bar.next-progress-62) {background-position: 50% 38%;}
  body:has(.progress-bar.progress-63), body.fade:has(.progress-bar.next-progress-63) {background-position: 50% 37%;}
  body:has(.progress-bar.progress-64), body.fade:has(.progress-bar.next-progress-64) {background-position: 50% 36%;}
  body:has(.progress-bar.progress-65), body.fade:has(.progress-bar.next-progress-65) {background-position: 50% 35%;}
  body:has(.progress-bar.progress-66), body.fade:has(.progress-bar.next-progress-66) {background-position: 50% 34%;}
  body:has(.progress-bar.progress-67), body.fade:has(.progress-bar.next-progress-67) {background-position: 50% 33%;}
  body:has(.progress-bar.progress-68), body.fade:has(.progress-bar.next-progress-68) {background-position: 50% 32%;}
  body:has(.progress-bar.progress-69), body.fade:has(.progress-bar.next-progress-69) {background-position: 50% 31%;}
  body:has(.progress-bar.progress-70), body.fade:has(.progress-bar.next-progress-70) {background-position: 50% 30%;}
  body:has(.progress-bar.progress-71), body.fade:has(.progress-bar.next-progress-71) {background-position: 50% 29%;}
  body:has(.progress-bar.progress-72), body.fade:has(.progress-bar.next-progress-72) {background-position: 50% 28%;}
  body:has(.progress-bar.progress-73), body.fade:has(.progress-bar.next-progress-73) {background-position: 50% 27%;}
  body:has(.progress-bar.progress-74), body.fade:has(.progress-bar.next-progress-74) {background-position: 50% 26%;}
  body:has(.progress-bar.progress-75), body.fade:has(.progress-bar.next-progress-75) {background-position: 50% 25%;}
  body:has(.progress-bar.progress-76), body.fade:has(.progress-bar.next-progress-76) {background-position: 50% 24%;}
  body:has(.progress-bar.progress-77), body.fade:has(.progress-bar.next-progress-77) {background-position: 50% 23%;}
  body:has(.progress-bar.progress-78), body.fade:has(.progress-bar.next-progress-78) {background-position: 50% 22%;}
  body:has(.progress-bar.progress-79), body.fade:has(.progress-bar.next-progress-79) {background-position: 50% 21%;}
  body:has(.progress-bar.progress-80), body.fade:has(.progress-bar.next-progress-80) {background-position: 50% 20%;}
  body:has(.progress-bar.progress-81), body.fade:has(.progress-bar.next-progress-81) {background-position: 50% 19%;}
  body:has(.progress-bar.progress-82), body.fade:has(.progress-bar.next-progress-82) {background-position: 50% 18%;}
  body:has(.progress-bar.progress-83), body.fade:has(.progress-bar.next-progress-83) {background-position: 50% 17%;}
  body:has(.progress-bar.progress-84), body.fade:has(.progress-bar.next-progress-84) {background-position: 50% 16%;}
  body:has(.progress-bar.progress-85), body.fade:has(.progress-bar.next-progress-85) {background-position: 50% 15%;}
  body:has(.progress-bar.progress-86), body.fade:has(.progress-bar.next-progress-86) {background-position: 50% 14%;}
  body:has(.progress-bar.progress-87), body.fade:has(.progress-bar.next-progress-87) {background-position: 50% 13%;}
  body:has(.progress-bar.progress-88), body.fade:has(.progress-bar.next-progress-88) {background-position: 50% 12%;}
  body:has(.progress-bar.progress-89), body.fade:has(.progress-bar.next-progress-89) {background-position: 50% 11%;}
  body:has(.progress-bar.progress-90), body.fade:has(.progress-bar.next-progress-90) {background-position: 50% 10%;}
  body:has(.progress-bar.progress-91), body.fade:has(.progress-bar.next-progress-91) {background-position: 50% 9%;}
  body:has(.progress-bar.progress-92), body.fade:has(.progress-bar.next-progress-92) {background-position: 50% 8%;}
  body:has(.progress-bar.progress-93), body.fade:has(.progress-bar.next-progress-93) {background-position: 50% 7%;}
  body:has(.progress-bar.progress-94), body.fade:has(.progress-bar.next-progress-94) {background-position: 50% 6%;}
  body:has(.progress-bar.progress-95), body.fade:has(.progress-bar.next-progress-95) {background-position: 50% 5%;}
  body:has(.progress-bar.progress-96), body.fade:has(.progress-bar.next-progress-96) {background-position: 50% 4%;}
  body:has(.progress-bar.progress-97), body.fade:has(.progress-bar.next-progress-97) {background-position: 50% 3%;}
  body:has(.progress-bar.progress-98), body.fade:has(.progress-bar.next-progress-98) {background-position: 50% 2%;}
  body:has(.progress-bar.progress-99), body.fade:has(.progress-bar.next-progress-99) {background-position: 50% 1%;}

  body:has(#result) {
    background: #FFFAEE;
    /* transition: none; */
  }

img {
  max-width: 100%;
}
#app {
  min-height: 100dvh;
  /* max-width: 800px; */
  margin: 0 auto;
}

.message-box {
    width: calc(100% - 3em);
    max-width: 480px;
    margin-inline: auto;
    box-sizing: border-box;
}

@media screen and (max-width: 768px) {
  body {
    touch-action: pan-x pan-y;
  }
}

.debug{
  background: #0006;
  border-radius: 0 1em 0 0;
  padding: 0.5rem;
  position: fixed;
  bottom: 0;
  left: 0;
  font-size: 0.7rem;
  text-align: left;
  z-index: 999999;
  &:hover,
  &:active {
    opacity: .3;
  }
}

</style>